
export enum PreNTPUpdate {
  LoanDocsSent = 'Loan Docs Sent',
  LoanDocsSigned = 'Loan Docs Signed',
  AmountsOrContractUpdated = 'Amounts or Contract Updated',
  PrequalSuccess = 'Customer Prequalified',
  AwaitingContract = 'Awaiting Contract',
}
